import { useCallback, useState } from 'react';

export const formatTime = (iso: string | null) => (iso ? new Date(iso).toLocaleString() : 'Never');

/** Runs an async task, tracking `busy` and the last error message. */
export function useAsync() {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const run = useCallback(async <T,>(task: () => Promise<T>): Promise<T | undefined> => {
    setBusy(true);
    setError('');
    try {
      return await task();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Something went wrong');
      return undefined;
    } finally {
      setBusy(false);
    }
  }, []);
  return { error, busy, run, setError };
}
